import { AuthenticationErrorCode } from '@/types/api/payment-user';
import ErrorModal from '../ErrorModal';

const codeToMessageMap = {
  [AuthenticationErrorCode.StartFailed]: 'BankID öppnades aldrig',
};

export interface AuthenticationFailedModalProps {
  errorCode: AuthenticationErrorCode;
}

export default function AuthenticationFailedModal({ errorCode }: AuthenticationFailedModalProps) {
  const message = codeToMessageMap[errorCode] || 'Någonting gick fel!';
  return <ErrorModal title="BankID verifiering misslyckades!" message={message} />;
}
